import { render, staticRenderFns } from "./OpportunityInfoDialog.vue?vue&type=template&id=55d53ee8&scoped=true"
import script from "./OpportunityInfoDialog.vue?vue&type=script&lang=js"
export * from "./OpportunityInfoDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d53ee8",
  null
  
)

export default component.exports